import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import DataTable from '../components/DataTable';
import LoadingSpinner from '../components/LoadingSpinner';
import { historiqueAPI, categoriesAPI, servicesAPI } from '../services/api';
import { toast } from 'react-toastify';
import ExportPDFButton from '../components/ExportPDFButton';

const HistoriquePage = () => {
  const [historique, setHistorique] = useState([]);
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterAction, setFilterAction] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const [filterService, setFilterService] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    loadData();
  }, [page, filterAction, filterCategory, filterService]);

  const loadData = async () => {
    try {
      setLoading(true);
      const [histRes, catRes, servRes] = await Promise.all([
        historiqueAPI.getAll({
          page,
          action: filterAction,
          category: filterCategory,
          service: filterService,
        }),
        categoriesAPI.getAll(),
        servicesAPI.getAll(),
      ]);

      setHistorique(histRes.data.data || histRes.data);
      setTotalPages(histRes.data.pagination?.pages || 1);
      setCategories(catRes.data.data || []);
      setServices(servRes.data.data || []);
    } catch (error) {
      toast.error('Erreur lors du chargement de l\'historique');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      key: 'created_at',
      label: 'Date',
      render: (val) => new Date(val).toLocaleString('fr-FR'),
    },
    { key: 'action', label: 'Action' },
    {
      key: 'immobilisation_nom',
      label: 'Immobilisation',
      render: (val, row) => (
        val ? (
          <Link to={`/immobilisations/${row.immobilisation_id}`} style={{ textDecoration: 'underline' }}>
            {val}
          </Link>
        ) : 'N/A'
      ),
    },
    {
      key: 'user_prenom',
      label: 'Utilisateur',
      render: (val, row) => row.user_prenom ? `${row.user_prenom} ${row.user_nom}` : 'N/A',
    },
  ];

  if (loading) {
    return (
      <div className="app-layout">
        <Sidebar />
        <div className="main-content">
          <Header />
          <div className="page-content" id="page-content">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="page-content" id="page-content">
          <div className="page-header">
            <h1 className="page-title">Historique des Actions</h1>
            <ExportPDFButton title="OGP IMMO - Historique" fileName="historique-ogp-immo" />
          </div>

          {/* Filters */}
          <div className="card" style={{ marginBottom: '1.5rem', padding: '1.5rem' }}>
            <div className="filter-group">
              <div className="filter-item">
                <label>Action</label>
                <select
                  value={filterAction}
                  onChange={(e) => {
                    setFilterAction(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="">Tous</option>
                  <option value="CREATE">Création</option>
                  <option value="UPDATE">Modification</option>
                  <option value="DELETE">Suppression</option>
                  <option value="SCAN">Scan</option>
                  <option value="ENROLL">Inscription</option>
                </select>
              </div>

              <div className="filter-item">
                <label>Catégorie</label>
                <select
                  value={filterCategory}
                  onChange={(e) => {
                    setFilterCategory(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="">Tous</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.nom}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-item">
                <label>Service</label>
                <select
                  value={filterService}
                  onChange={(e) => {
                    setFilterService(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="">Tous</option>
                  {services.map((svc) => (
                    <option key={svc.id} value={svc.id}>
                      {svc.nom}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="card">
            <DataTable
              columns={columns}
              data={historique}
              loading={loading}
              pagination={{
                page,
                totalPages,
                onPageChange: setPage,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoriquePage;
